export function switchList<T>(list: Array<T>) {
  return {
    add: (item: T) => [...list, item],
    remove: (item: T) => list.filter((i) => i !== item),
    find: (item: T) => list.includes(item),
  };
}
